<template lang="pug">
//- div
//- 	#bg
//- 		img(src="../assets/images/nyc-grand-and-centered.jpg")
//- 		.hero-text
//- 			h1 Novas Ignaras Gambiarras
//- 			md-button.md-accent.md-raised Apertar
div

	.md-layout.md-gutter.md-alignment-center-space-around.center
		.md-layout-item.md-alignment-end-center.md-medium-size-33.md-small-size-100
			.card-expansion
				md-card(style="width: 100%; height: 100%")
					md-card-media
						img(src='../assets/images/nyc-dynamo.jpg' alt='People')
					md-card-header
						.md-title.black Massive Delays
						.md-subhead Radial Meetings
					md-card-expand
						md-card-actions(md-alignment='space-between')
							div
								md-button.md-primary.md-raised Fraction
								md-button.md-accent.md-raised Friction
							md-card-expand-trigger
								md-button.md-icon-button
									md-icon keyboard_arrow_down
						md-card-expand-content
							md-card-content.
								
								Λορεμ ιπσθμ δολορ σιτ αμετ, qθι ει ερρορ επιcθρει σιγνιφερθμqθε. Ναμ τε γραεcο προπριαε, αδ ταcιματεσ μοδερατιθσ δισσεντιθντ πρι. Λεγερε ιισqθε ελοqθεντιαμ vελ θτ. Εστ νιηιλ ελαβοραρετ ιν. Ιδ vελ φαλλι τραcτατοσ σcριπσεριτ, ει ιθσ ζριλ φαcιλισι ηονεστατισ.

		.md-layout-item.md-alignment-center-center.md-medium-size-33.md-small-size-100
			.card-expansion
				md-card(style="width: 100%; height: 100%")
					md-card-media
						img(src='../assets/images/nyc-dynamo.jpg' alt='People')
					md-card-header
						.md-title.black Massive Delays
						.md-subhead Radial Meetings
					md-card-expand
						md-card-actions(md-alignment='space-between')
							div
								md-button.md-primary.md-raised Fraction
								md-button.md-accent.md-raised Friction
							md-card-expand-trigger
								md-button.md-icon-button
									md-icon keyboard_arrow_down
						md-card-expand-content
							md-card-content.
								
								Λορεμ ιπσθμ δολορ σιτ αμετ, qθι ει ερρορ επιcθρει σιγνιφερθμqθε. Ναμ τε γραεcο προπριαε, αδ ταcιματεσ μοδερατιθσ δισσεντιθντ πρι. Λεγερε ιισqθε ελοqθεντιαμ vελ θτ. Εστ νιηιλ ελαβοραρετ ιν. Ιδ vελ φαλλι τραcτατοσ σcριπσεριτ, ει ιθσ ζριλ φαcιλισι ηονεστατισ.

		.md-layout-item.md-alignment-center-center.md-medium-size-33.md-small-size-100
			.card-expansion
				md-card(style="width: 100%; height: 100%")
					md-card-media
						img(src='../assets/images/nyc-dynamo.jpg' alt='People')
					md-card-header
						.md-title.black Massive Delays
						.md-subhead Radial Meetings
					md-card-expand
						md-card-actions(md-alignment='space-between')
							div
								md-button.md-primary.md-raised Fraction
								md-button.md-accent.md-raised Friction
							md-card-expand-trigger
								md-button.md-icon-button
									md-icon keyboard_arrow_down
						md-card-expand-content
							md-card-content.
								
								Λορεμ ιπσθμ δολορ σιτ αμετ, qθι ει ερρορ επιcθρει σιγνιφερθμqθε. Ναμ τε γραεcο προπριαε, αδ ταcιματεσ μοδερατιθσ δισσεντιθντ πρι. Λεγερε ιισqθε ελοqθεντιαμ vελ θτ. Εστ νιηιλ ελαβοραρετ ιν. Ιδ vελ φαλλι τραcτατοσ σcριπσεριτ, ει ιθσ ζριλ φαcιλισι ηονεστατισ.


</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style lang="scss" scoped>

	#bg {
	position: fixed; 
	top: -50%; 
	left: -50%; 
	width: 200%; 
	height: 200%;
	}

	#bg img {
	position: absolute; 
	top: 0; 
	left: 0; 
	right: 0; 
	bottom: 0; 
	margin: auto; 
	min-width: 50%;
	min-height: 50%;
	}

	.hero-image {
		background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("../assets/images/linotpographer.jpg");
		height: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		position: relative;
	}


	.hero-text {
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: white;
	}

  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
	vertical-align: top;
	padding: 25px;
	text-align: left;
  }

.md-subhead {
	font-size: 18px !important;
	margin-top: 7px !important;
}

</style>